import { useEffect } from 'react';

let activeLocks = 0;
let lockedScrollY = 0;
let previousBodyStyles: Partial<CSSStyleDeclaration> | undefined;

export const useLockBodyScroll = (lock: boolean) => {
	useEffect(() => {
		if (!lock) return;

		if (activeLocks === 0) {
			lockedScrollY = window.scrollY;
			previousBodyStyles = {
				position: document.body.style.position,
				top: document.body.style.top,
				left: document.body.style.left,
				right: document.body.style.right,
				overflow: document.body.style.overflow,
				width: document.body.style.width,
			};

			Object.assign(document.body.style, {
				position: 'fixed',
				top: `-${lockedScrollY}px`,
				left: '0',
				right: '0',
				overflow: 'hidden',
				width: '100%',
			});
		}

		activeLocks += 1;

		return () => {
			activeLocks = Math.max(activeLocks - 1, 0);

			if (activeLocks > 0) return;

			Object.assign(document.body.style, {
				position: previousBodyStyles?.position ?? '',
				top: previousBodyStyles?.top ?? '',
				left: previousBodyStyles?.left ?? '',
				right: previousBodyStyles?.right ?? '',
				overflow: previousBodyStyles?.overflow ?? '',
				width: previousBodyStyles?.width ?? '',
			});
			window.scrollTo(0, lockedScrollY);
			lockedScrollY = 0;
			previousBodyStyles = undefined;
		};
	}, [lock]);
};
